import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useData, useStatus, isNormal, isLoading } from 'resift';
import makeGetWidgetLayout from 'fetches/homepageWidgets/makeGetWidgetLayout';
import CircularProgress from '@material-ui/core/CircularProgress';
import LayoutTab from './LayoutTab';

function Container() {
  const dispatch = useDispatch();
  const getDefaultWidgetLayout = makeGetWidgetLayout('default');
  const getWidgetLayoutStatus = useStatus(getDefaultWidgetLayout);
  const defaultWidgetLayout = useData(getDefaultWidgetLayout);

  useEffect(() => {
    dispatch(getDefaultWidgetLayout());
  }, []);

  if (isLoading(getWidgetLayoutStatus)) {
    return <CircularProgress color="secondary" />;
  }

  if (!isNormal(getWidgetLayoutStatus)) {
    return <div>Something went wrong</div>;
  }

  return <LayoutTab widgetsOnDefaultLayout={defaultWidgetLayout.widgets} />;
}

export default Container;
